import _ from 'lodash';
import { CampaignRecipient, CustomField } from '@/types';

export default function extract(recipients: CampaignRecipient[]): string[] {
  if (!recipients) return [];
  const customFields: string[] = [];
  recipients.forEach((recipient) => {
    if (!_.has(recipient, 'customFields')) {
      return;
    }
    recipient.customFields.forEach((recipientCustomField) => {
      if (!customFields.includes(recipientCustomField.id)) {
        customFields.push(recipientCustomField.id);
      }
    });
  });
  return customFields;
}

export function getCustomFieldValue(
  customFieldId: string, recipientsCustomFields: CustomField[],
): string {
  const recipientCustomField = recipientsCustomFields.find(rcf => rcf.id === customFieldId);
  if (!recipientCustomField) {
    return '';
  }
  return recipientCustomField.name;
}
